import { lazy } from 'react';

import { lookupsStore } from 'src/stores/lookups';
import { MinervaRoute } from 'src/utils/router';

import { createActivityDashboard } from './components/ActivityDashboard';
import { assetsStore } from './store';

export interface AssetsParams {
  implementationRecordSubCategoryId?: string;
  activityId?: string;
}

export const { ActivityDashboard, activityDashboardStore } =
  createActivityDashboard();

export const AssetsRoute: MinervaRoute<'activity-manager', AssetsParams> = {
  name: 'activity-manager',
  path: '/activity-manager?parentLocation&activityId',
  comp: () => lazy(() => import('./index')),

  activate: async (_, params) => {
    assetsStore.filter.resetFilters();
    assetsStore.filter.resetPersistedFilters();
    if (!!params?.implementationRecordSubCategoryId) {
      assetsStore.filter.setFilterValue({
        'q.implementationRecordSubCategory.id':
          params?.implementationRecordSubCategoryId,
      });
    }
    if (!!params?.activityId) {
      assetsStore.filter.setFilterValue({
        'q.ids': [Number(params?.activityId)],
      });
    }
    activityDashboardStore.loadData();
    await assetsStore.fetchAssets();
  },
  deactivate: () => {
    assetsStore.resetStore();
    lookupsStore.resetJurisdictions();
  },
};
